import { Component, Input, Optional } from '@angular/core';
import { NgClass } from '@angular/common';
import { UiText } from '../../../../sdk/kratos';

@Component({
    selector: 'app-messages',
    imports: [
    NgClass
],
    templateUrl: './messages.component.html',
    styleUrl: './messages.component.less'
})
export class MessagesComponent {
  @Input()
  @Optional()
  messages?: UiText[];
}
